/**
 * Human message out of an RTK Query rejection. The API wraps errors as
 * `{ error: { code, message, details } }`; older handlers used
 * `{ detail: string | { message } }`. Returns '' when nothing usable is there,
 * including when the request never reached the server: RTK reports that as
 * "TypeError: Failed to fetch", which is not something to show a person.
 */
export function apiErrorMessage(error: unknown): string {
  const status = (error as { status?: unknown })?.status;
  if (
    status === 'FETCH_ERROR' ||
    status === 'TIMEOUT_ERROR' ||
    status === 'PARSING_ERROR'
  )
    return '';
  const data = (error as { data?: unknown })?.data;
  if (typeof data === 'string') return data;
  if (data && typeof data === 'object') {
    const envelope = (data as { error?: unknown }).error;
    if (envelope && typeof envelope === 'object') {
      const message = (envelope as { message?: unknown }).message;
      if (typeof message === 'string') return message;
    }
    const detail = (data as { detail?: unknown }).detail;
    if (typeof detail === 'string') return detail;
    if (detail && typeof detail === 'object') {
      const message = (detail as { message?: unknown }).message;
      if (typeof message === 'string') return message;
    }
    const message = (data as { message?: unknown }).message;
    if (typeof message === 'string') return message;
  }
  const top = (error as { error?: unknown })?.error;
  return typeof top === 'string' ? top : '';
}

/**
 * The API's own code of a refusal (`session_expired`, `drafts_changed`, ...):
 * the bare `{ error: "code" }`, or `{ error: { details: { error } } }` inside
 * the envelope. '' when there is none.
 */
export function apiErrorCode(error: unknown): string {
  const body = (error as { data?: { error?: unknown } })?.data?.error;
  const code =
    typeof body === 'string'
      ? body
      : (body as { details?: { error?: unknown } } | undefined)?.details?.error;
  return typeof code === 'string' ? code : '';
}
